import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from 'emailjs-com';
import './App.css';
import WelcomeScreen from './components/WelcomeScreen';
import BoxGrid from './components/BoxGrid';
import InspirationPopup from './components/InspirationPopup';
import MessagePopup from './components/MessagePopup';

const EMAILJS_SERVICE_ID = 'service_agxsr46';
const EMAILJS_TEMPLATE_ID = 'template_bh4g4yf';
const EMAILJS_PUBLIC_KEY = 'aznVMfdPCux_890l3';

const StomachMemePopup = ({ onNext }) => (
  <motion.div
    className="popup-overlay"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <motion.div
      className="no-message-sheet"
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      exit={{ y: '100%' }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      onClick={e => e.stopPropagation()}
    >
      <div className="popup-handle" />
      <div className="meme-wrapper">
        <div className="meme-text-top">Eppa paaathaalum...<br/>Soooruuu Soooruuu Soooruuu</div>
        <img
          src="https://i.ibb.co/TMMH0L2P/13291.jpg"
          alt="Sooru"
          className="meme-img"
          onError={e => { e.target.style.display='none'; }}
        />
      </div>
      <button className="close-btn" style={{ marginTop: '16px' }} onClick={onNext}>
        Okay okay 😂
      </button>
    </motion.div>
  </motion.div>
);

const initialBoxes = [
  {
    id: 'mornings',
    name: 'For your Mornings',
    emoji: '🌅',
    opened: false,
    question: 'Indha box ku inspiration theriyanuma??',
    inspiration: 'Daily kaalaila enna elupi vuttu saavadikuraela... adhaan inspiration ae idhuku....',
    closeMsg: 'Easy ya guess pannalaam',
  },
  {
    id: 'kranky',
    name: 'For your Kranky Nights',
    emoji: '🌙',
    opened: false,
    question: 'Ee box ge inspiration enu anta theliyabekka?',
    inspiration: 'Enna dhan sandhosam depression nu endha extreme la irundhaalum correct time ku thoongura paathiya... adhaan inspiration ae idhuku....',
    closeMsg: 'Guess panriya? Kudukava?',
  },
  {
    id: 'stomach',
    name: 'For your Stomach',
    emoji: '🍱',
    opened: false,
    question: 'Is box ki inspiration jaan-na chahte ho?',
    inspiration: 'Therinjae aaganumaa... unakae theriyum la... epa paathalum soooru soooru soooru... adhaan inspiration ae....',
    closeMsg: 'Guesss pannnunnngeee',
  },
  {
    id: 'beauty',
    name: 'For your Beauty',
    emoji: '✨',
    opened: false,
    question: 'Want to know the inspiration for this box?',
    inspiration: 'Idhu konjam unnecessary gift thaan… Already azhaga irukka person ku beauty gift vaangaradhu unnecessary dhana !!! Bought it without inspiration :)',
    closeMsg: 'Thanks vendaam plz',
  },
  {
    id: 'heart',
    name: 'For your Heart',
    emoji: '🖤',
    opened: false,
    question: 'Ee box inu inspiration enthaanu enn ariyano?',
    inspiration: 'Secrettt...',
    closeMsg: 'Check your mail',
  },
  {
    id: 'comfort',
    name: 'For your Comfort',
    emoji: '🧸',
    opened: false,
    question: 'Ee box ki inspiration telusukovala?',
    inspiration: 'Comfort zone ah vittu enakaaga you came out of your comfort zone sometimess... adhaan idhuuu...',
    closeMsg: 'Summar dhan la indha box uh?',
  },
];

// Floating particles
const Particles = () => {
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    size: Math.random() * 10 + 4,
    left: Math.random() * 100,
    duration: Math.random() * 14 + 8,
    delay: Math.random() * 10,
    color: ['#87CEEB', '#B8E4F5', '#ffffff', '#5BB8D4', '#d6f0ff', '#c9eeff'][Math.floor(Math.random() * 6)],
  }));

  return (
    <div className="particles">
      {particles.map(p => (
        <div
          key={p.id}
          className="particle"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.left}%`,
            bottom: '-20px',
            background: p.color,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

function App() {
  const [screen, setScreen] = useState('welcome'); // welcome | boxes | done
  const [boxes, setBoxes] = useState(initialBoxes);
  const [activeBox, setActiveBox] = useState(null);
  const [popupState, setPopupState] = useState(null); // null | 'stomachmeme' | 'inspiration' | 'yes' | 'no'
  const [emailStatus, setEmailStatus] = useState(null); // null | sending | sent | error

  const openedCount = boxes.filter(b => b.opened).length;

  const handleBoxOpen = (box) => {
    setActiveBox(box);
    setEmailStatus(null);
    const isFirstOpen = boxes.filter(b => b.opened).length === 0;
    if (box.id === 'stomach' && isFirstOpen) {
      setPopupState('stomachmeme');
    } else {
      setPopupState('inspiration');
    }
  };

  const handleYes = async () => {
    setPopupState('yes');

    if (activeBox.id === 'heart') {
      setEmailStatus('sending');
      try {
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          { to_email: 'krishnapriyaks0399@gmail.com' },
          EMAILJS_PUBLIC_KEY
        );
        setEmailStatus('sent');
      } catch (err) {
        console.error(err);
        setEmailStatus('error');
      }
    }
  };

  const handleNo = () => {
    setPopupState('no');
  };

  const handleClose = () => {
    // Mark box as opened
    if (activeBox) {
      setBoxes(prev =>
        prev.map(b => b.id === activeBox.id ? { ...b, opened: true } : b)
      );
    }
    setPopupState(null);
    setActiveBox(null);
    setEmailStatus(null);

    // Check if all opened
    const newOpened = boxes.filter(b => b.opened).length + 1;
    if (newOpened === 6) {
      setTimeout(() => setScreen('done'), 400);
    }
  };

  return (
    <div className="app">
      <Particles />

      <AnimatePresence mode="wait">
        {screen === 'welcome' && (
          <motion.div
            key="welcome"
            style={{ width: '100%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4 }}
          >
            <WelcomeScreen onEnter={() => setScreen('boxes')} />
          </motion.div>
        )}

        {screen === 'boxes' && (
          <motion.div
            key="boxes"
            style={{ width: '100%' }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <BoxGrid
              boxes={boxes}
              onOpen={handleBoxOpen}
              openedCount={openedCount}
            />
          </motion.div>
        )}

        {screen === 'done' && (
          <motion.div
            key="done"
            className="done-screen"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, type: 'spring' }}
          >
            <div className="done-emoji">🎉</div>
            <div className="done-title">That's all KP!</div>
            <div className="done-message">
              Ellam open panniteenga... Hope you loved every single one of them 🥹<br/><br/>
              Pudicha box edhu nu sllitu poonga :)
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Popups */}
      <AnimatePresence>
        {popupState === 'stomachmeme' && activeBox && (
          <StomachMemePopup
            key="stomachmeme"
            onNext={() => setPopupState('inspiration')}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {popupState === 'inspiration' && activeBox && (
          <InspirationPopup
            key="inspiration"
            box={activeBox}
            onYes={handleYes}
            onNo={handleNo}
            onClose={() => {
              setPopupState(null);
              setActiveBox(null);
            }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {(popupState === 'yes' || popupState === 'no') && activeBox && (
          <MessagePopup
            key="message"
            box={activeBox}
            type={popupState}
            onClose={handleClose}
            emailStatus={emailStatus}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
